import { PublicFooter } from "@/components/common/PublicFooter";
import { PublicNav } from "@/components/common/PublicNav";

export function About() {
  return (
    <div className="sa-page" style={{ display: "flex", flexDirection: "column" }}>
      <PublicNav />

      <article
        className="sa-about-page"
        style={{
          maxWidth: 680,
          margin: "0 auto",
          padding: "96px 40px 96px",
          width: "100%",
        }}
      >
        <div className="sa-label" style={{ marginBottom: 24 }}>
          About
        </div>
        <h1
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 400,
            fontSize: 52,
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            margin: "0 0 40px",
          }}
        >
          <span style={{ fontStyle: "italic" }}>On</span> the nature of this instrument.
        </h1>

        <p
          style={{
            fontSize: 18,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
            marginBottom: 28,
          }}
        >
          SubmitterAI is a retrieval instrument. It reads a question, locates the Quranic
          passages most relevant to it, and composes a response that stays within the
          bounds of that scripture. It is not a teacher. It is not an authority. It is an
          index that can speak.
        </p>

        <hr className="sa-hair" style={{ margin: "56px 0" }} />

        <h2
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 28,
            margin: "0 0 18px",
            letterSpacing: "-0.01em",
          }}
        >
          What this is
        </h2>
        <p
          style={{
            fontSize: 17,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
            marginBottom: 40,
          }}
        >
          A conversational surface over the Quran. Each answer is constructed by
          retrieving specific verses, then synthesizing them. The verses themselves are
          the citation — you should read them.
        </p>

        <h2
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 28,
            margin: "0 0 18px",
            letterSpacing: "-0.01em",
          }}
        >
          What it is not
        </h2>
        <p
          style={{
            fontSize: 17,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
            marginBottom: 16,
          }}
        >
          This instrument does not draw from Hadith, Sunnah, or any secondary tradition.
          It does not issue religious rulings. It will not speculate beyond what the Quran
          states. When the scripture is silent on a matter, the instrument will say so.
        </p>

        <div
          style={{
            margin: "48px 0",
            paddingLeft: 32,
            borderLeft: "2px solid var(--sa-accent)",
            fontFamily: "var(--sa-mono)",
            fontSize: 14,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
          }}
        >
          <div
            style={{
              fontSize: 11,
              color: "var(--sa-muted-fg)",
              marginBottom: 10,
              letterSpacing: "0.08em",
            }}
          >
            SCOPE GUARD — Quran 6:114
          </div>
          “Shall I seek other than GOD as a source of law, when He has revealed to you
          this book fully detailed?”
        </div>

        <h2
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 28,
            margin: "0 0 18px",
            letterSpacing: "-0.01em",
          }}
        >
          Sources
        </h2>
        <p
          style={{
            fontSize: 17,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
            marginBottom: 16,
          }}
        >
          Responses are assembled from four tiers, in order of authority:
        </p>
        <ol
          style={{
            fontFamily: "var(--sa-serif)",
            fontSize: 16,
            lineHeight: 1.9,
            paddingLeft: 24,
            marginBottom: 40,
            color: "var(--sa-fg)",
          }}
        >
          <li>
            <em>Quran</em> — the verse text itself, always primary.
          </li>
          <li>
            <em>Messenger</em> — the prophetic context in which verses were revealed.
          </li>
          <li>
            <em>Scholarly</em> — commentary strictly on scope, never on interpretation.
          </li>
          <li>
            <em>FAQ</em> — frequently-asked framings, resolved back to verse citations.
          </li>
        </ol>

        <h2
          style={{
            fontFamily: "var(--sa-serif)",
            fontWeight: 500,
            fontSize: 28,
            margin: "0 0 18px",
            letterSpacing: "-0.01em",
          }}
        >
          Privacy
        </h2>
        <p
          style={{
            fontSize: 17,
            lineHeight: 1.7,
            color: "var(--sa-fg)",
            marginBottom: 16,
          }}
        >
          Guest conversations are held in the browser tab and expire when it closes. For
          signed-in users, conversations are stored on the server so they may be resumed.
          We do not share, sell, or train third-party models on this data.
        </p>

        <hr className="sa-hair" style={{ margin: "56px 0 40px" }} />

        <div
          style={{
            fontFamily: "var(--sa-sans)",
            fontSize: 13,
            color: "var(--sa-muted-fg)",
          }}
        >
          Typeset in Source Serif and JetBrains Mono. Built with deliberate restraint.
        </div>
      </article>

      <PublicFooter />
    </div>
  );
}
